import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {Button, Loading} from "~/components";
import {SelectUserAll} from "~/components/Forms";

function MarketingProjectFormAssign({item, onHandleSubmit}) {

	const assignOptions = item?.assign?.id
		? [{label: `${item.assign.firstname} ${item.assign.lastname}`, value: item.assign.id}]
		: [];

	const initialValues = {
		assignId: item?.assignId || '',
	}

	const validationSchema = Yup.object().shape({
		assignId: Yup.number().typeError('Bạn chưa chọn nhân viên kỹ thuật').required('Bạn chưa chọn nhân viên kỹ thuật'),
	});

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() => {
		reset(initialValues);
	}, [item]);

	const onSubmit = async (data) => {
		await onHandleSubmit(data, item);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Nhân viên kỹ thuật phụ trách dự án</p>
			<Controller control={control} name="assignId" render={({field}) => (
				<SelectUserAll placeholder="Chọn nhân viên kỹ thuật" department="marketingTechnical" options={assignOptions} errors={errors} {...field} />
			)}/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Phân công kỹ thuật</Button>
			</div>
		</form>
	)
}

export default MarketingProjectFormAssign;
